(function () {
  'use strict';

  /* @ngdoc object
   * @name uos
   * @description
   *
   */
  angular
    .module('uos', [
      'ui.router',
      'alert-message',
      'ComponentsVfiltroModule',
      'uoModule',
      'uoArvoreNivelModule',
      'v3gAuthenticatorModule',
      'enumModule',
      'vUuidMaskModule'
    ]);
}());
